import StruttureList from "./components/StruttureList.vue";
import StrutturaView from "./components/StrutturaView.vue";
import StrutturaEdit from "./components/StrutturaEdit.vue";

export default {
    StruttureList,
    StrutturaView,
    StrutturaEdit,
};
